import { render, staticRenderFns } from "./StudentCourseForm.vue?vue&type=template&id=745a68d4&scoped=true&"
import script from "./StudentCourseForm.vue?vue&type=script&lang=js&"
export * from "./StudentCourseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a68d4",
  null
  
)

export default component.exports